import { ref, computed } from 'vue'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/firebase'
import { getCurrentClientAdmin } from '@/service/api'

const adminProfile = ref(null)
const isLoadingAdmin = ref(false)
let fetchPromise = null
let isAuthListenerBound = false
const forceSuperAdmin = true
//(import.meta && import.meta.env && import.meta.env.VITE_FORCE_SUPER_ADMIN) === 'true' ||
//process.env.VUE_APP_FORCE_SUPER_ADMIN === 'true'

function resetAdminProfile() {
  adminProfile.value = null
  fetchPromise = null
}

function bindAuthListenerOnce() {
  if (isAuthListenerBound) return
  onAuthStateChanged(auth, (user) => {
    if (!user) {
      resetAdminProfile()
    }
  })
  isAuthListenerBound = true
}

async function loadAdminProfile() {
  if (!auth.currentUser) {
    resetAdminProfile()
    return null
  }

  isLoadingAdmin.value = true
  try {
    const { data, status } = await getCurrentClientAdmin()
    if (status === 200) {
      adminProfile.value = data.data
    } else {
      adminProfile.value = null
    }
  } catch (err) {
    console.error('Failed to fetch current admin profile:', err)
    adminProfile.value = null
  } finally {
    isLoadingAdmin.value = false
  }

  return adminProfile.value
}

async function ensureAdminProfileLoaded() {
  bindAuthListenerOnce()

  if (adminProfile.value) {
    return adminProfile.value
  }

  if (!fetchPromise) {
    fetchPromise = loadAdminProfile().finally(() => {
      fetchPromise = null
    })
  }

  return fetchPromise
}

export function useCurrentAdmin() {
  bindAuthListenerOnce()

  const role = computed(() => adminProfile.value?.role || null)
  const isSuperAdmin = computed(
    () => forceSuperAdmin || role.value === 'super_admin'
  )

  const refreshAdminProfile = () => {
    adminProfile.value = null
    return ensureAdminProfileLoaded()
  }

  return {
    adminProfile,
    role,
    isSuperAdmin,
    isLoadingAdmin,
    ensureAdminProfileLoaded,
    refreshAdminProfile
  }
}
